import React from "react";
import { Outlet } from "react-router-dom";
import Nav from "./Nav";

const CarLayout = () => {
  return (
    <div>
      <Nav />
      <div className="">
        <Outlet />
      </div>
    </div>
  );
};

export default CarLayout;
